import * as React from "react";
import { Provider } from "react-redux";

import analyseStore, { initialState } from "./store";
import AnalyseApp from "./AnalyseApp";
import { useParams } from "react-router-dom";

declare const window: Window;

interface AnalysisAppUrlParams {
    primarySetId: string;
    isViewOnly: string;
}

const escapeSpacebarForElementIds = [
    "zoomLevelSlider",
    "CurrentPosition",
    "EventType",
    "ToggleWaveform"
];

export const AnalyseAppProvider = () => {
    const { primarySetId, isViewOnly } = useParams<AnalysisAppUrlParams>();
    // Hijacks spacebar keydown events and makes sure for some specific scenarios (elements) it propagates over to the playback.
    React.useEffect(() => {
        const keyDownListener = (e: KeyboardEvent & { target: EventTarget & { id: string } }) => {
            if (
                e.code === "Space" &&
                escapeSpacebarForElementIds.indexOf(e.target.id) > -1
            ) {
                e.preventDefault();
                document.getElementById("Playback").click();
            }
        }

        window.addEventListener("keydown", keyDownListener);

        return () => window.removeEventListener("keydown", keyDownListener);
    }, []);

    const store = analyseStore(
        initialState(primarySetId, isViewOnly === "true")
    );

    return (
        <Provider store={store}>
            <AnalyseApp />
        </Provider>
    );
};
